import Grid from '@mui/material/Grid';

import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

import { useAuth } from 'auth';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { useLocale } from 'lib/i18n/client';
import { getTranslations } from 'lib/i18n/dictionary';

import { ReviewModerationBoard } from './review-moderation-board';

// Matcha's moderation of Reviews and Review reports; the API allows it only to moderators.
function Reviews() {
  const { accessToken } = useAuth();
  const locale = useLocale();
  const translations = getTranslations(locale).reviewsPage;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SoftTypography variant="h4" fontWeight="medium" mb={2}>
              {translations.title}
            </SoftTypography>
            <ReviewModerationBoard
              accessToken={accessToken ?? undefined}
              locale={locale}
              translations={translations}
            />
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Reviews;
